"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "attendeeRosterChanged", {
  enumerable: true,
  get: function get() {
    return _attendeeRosterChanged["default"];
  }
});
var _attendeeRosterChanged = _interopRequireDefault(require("./attendeeRosterChanged"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }